import { render } from "./ReorerPad.vue?vue&type=template&id=6add4d4f"
import script from "./ReorerPad.vue?vue&type=script&lang=js"
export * from "./ReorerPad.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__